/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:37 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var template = require("connection-templates/connectionPanelLayout.tmpl");
    var DomUtilities = require("infra-util/DomUtilities");

    require("jqueryui/draggable");

    var ConnectionPanelLayout = {};
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        ConnectionPanelLayout = Marionette.Layout.extend({
            className: 'connection-panel-layout',
            template: template,
            elementOffset:5,
            elementOffsets: {
                top: 75,
                bottom: 0
            },

            regions: {
                handleRegion: ".handle-region",
                mainContainerRegion: ".connection-panel-container .main-container-region",
                articleRegion: ".connection-panel-container .article-container-region",
                ticketRegion: ".connection-panel-container .ticket-container-region",
                notificationRegion: ".connection-panel-container .notification-container-region"
            },
            ui: {
                handleRegion: ".handle-region",
                mainContainerRegion: ".connection-panel-container .main-container-region",
                articleRegion: ".connection-panel-container .article-container-region",
                ticketRegion: ".connection-panel-container .ticket-container-region",
                notificationRegion: ".connection-panel-container .notification-container-region",
                connectionPanelContainer: ".connection-panel-container"
            },
            events: {
                "click .handle-region": "_openConnectionPanel",
                "mouseover .handle-region": "_onHandleHover"
            },
            initialize: function() {
                this._transitionSupport = DomUtilities.isTransitionSupported();
            },

            onRender: function () {
                this._bindEvents();
                this._initContainerState();
            },

            _bindEvents:function(){
                this.listenTo(LEConnection.vent,"standalone:adjustments", this._adjustStandalone,this);
                this.listenTo(this.model,"change:isOpen",this._manageConnectionPanelContainerState,this);
            },

            _onHandleHover: function () {
                if (!this.isHandleHover) {
                    this.isHandleHover = true;
                    this.ui.handleRegion.draggable({
                        axis: "y",
                        containment: [0, this.elementOffsets.top, 0, (this.$el.height() - this.elementOffsets.bottom)],
                        scroll: false
                    });
                }
            },
            _openConnectionPanel: function () {
                LEConnection.vent.trigger("ConnectionPanelLayoutController:openConnectionPanel");
            },
            _manageConnectionPanelContainerState: function (model, isOpen) {
                if (isOpen) {
                    this._openConnectionPanelContainer();
                }
                else {
                    this._closeConnectionPanelContainer();
                }
            },

            _openConnectionPanelContainer: function () {
                this.ui.mainContainerRegion.removeClass("hide");
                this.ui.articleRegion.removeClass("hide");
                this.ui.ticketRegion.removeClass("hide");
                this.ui.notificationRegion.removeClass("hide");
                this.ui.connectionPanelContainer.removeClass("close");
                this.ui.handleRegion.addClass("hide");
            },

            _closeConnectionPanelContainer: function () {
                var that = this;
                this.ui.connectionPanelContainer.addClass("close");
                if (this._transitionSupport) {
                    this.ui.connectionPanelContainer.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",closeConnectionPanel);
                } else {
                    closeConnectionPanel();
                }

                function closeConnectionPanel() {
                    if (!that.model.get("isOpen")) {
                        that.ui.articleRegion.addClass("hide");
                        that.ui.ticketRegion.addClass("hide");
                        that.ui.notificationRegion.addClass("hide");
                        that.ui.handleRegion.removeClass("hide");
                        var handlePosition = that.ui.handleRegion.position();
                        //todo: check mouse position
                        if (handlePosition.top < 85) {
                            that.model.set("holdHover", true);
                        }
                        that.ui.mainContainerRegion.addClass("hide");
                    }
                }
            },

            _initContainerState: function () {
                //if CP is open on LE starts CP should open after a second (for the user to notice it)
                var isOpen = this.model.get("isOpen");
                if (isOpen) {
                    var that = this;
                    this._manageConnectionPanelContainerState(this.model, false);
                    setTimeout(function () {
                        that._manageConnectionPanelContainerState(that.model, isOpen);
                    }.bind(this), 1000);
                }
            },

            _adjustStandalone: function(){
                $(document).on("mouseleave", function() {
                    $(document).trigger("mouseup");
                });
                var $doc = $(document);
                $doc.on("mouseleave", function() {
                    $doc.trigger("mouseup");
                });
                this.elementOffsets = {};
                this.elementOffsets.top = 0;
                this.elementOffsets.bottom = 100;
            }

        });
    });
    return ConnectionPanelLayout;
});

